export enum CompanyType {
  Private = 1,
  Business = 2
}
